
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9 0a9 9 0 000 18 1.498 1.498 0 001.11-2.505 1.486 1.486 0 01-.375-.995c0-.83.67-1.5 1.5-1.5H13c2.76 0 5-2.24 5-5 0-4.42-4.03-8-9-8zM3.5 9C2.67 9 2 8.33 2 7.5S2.67 6 3.5 6 5 6.67 5 7.5 4.33 9 3.5 9zm3-4C5.67 5 5 4.33 5 3.5S5.67 2 6.5 2 8 2.67 8 3.5 7.33 5 6.5 5zm5 0c-.83 0-1.5-.67-1.5-1.5S10.67 2 11.5 2s1.5.67 1.5 1.5S12.33 5 11.5 5zm3 4c-.83 0-1.5-.67-1.5-1.5S13.67 6 14.5 6s1.5.67 1.5 1.5S15.33 9 14.5 9z"}})])
          )
        }
      }
    